import Err from '../../models/err';

export default function createNotNumberError(attrName) {
  return new Err({ code: Err.Code.NOT_A_NUMBER, attr: attrName, detail: 'Please enter a valid number' });
}
